// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__ED5OR"};